import DIV, { div } from '../../DOM/div/DIV.js';
/** An Horizontal Flex Element */
export default class FLEXHORIZONTAL extends DIV {
    left;
    center;
    right;
    constructor(node, model) {
        super(node, model);
        this.addClass('flex-horizontal');
        this.left = new DIV(this, div('flex-left'));
        this.center = new DIV(this, div('flex-center'));
        this.right = new DIV(this, div('flex-right'));
    }
}
